import { Component, Input, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
  selector: "app-variables-tabs",
  templateUrl: "./variables-tabs.component.html",
  styleUrls: ["./variables-tabs.component.scss"],
})
export class VariablesTabsComponent implements OnInit {

    @Input() public serviceId: string;
    @Input() public primarySelectedTab: string = "";

    public variablesTabs: any[];

    constructor(private router: Router, private activatedRoute: ActivatedRoute) { }

    public ngOnInit() {

        this.activatedRoute.params.subscribe((params) => {
            this.serviceId = params.serviceId;
        });
        this.init();
    }

    private init() {
        // route list
        this.variablesTabs = [
            { link: `/services/${this.serviceId}/variables/instance-catalogs`, translation: "Instance Catalogs", isActive: false, name: "InstanceCatalogs" },
            { link: `/services/${this.serviceId}/variables/tables`, translation: "Tables", isActive: false, name: "Tables" },
            { link: `/services/${this.serviceId}/variables/cross-tables`, translation: "Cross Tables", isActive: false, name: "CrossTables" },
        ];

        this.chooseSectionByUrlAndRevealIt();
    }

    private chooseSectionByUrlAndRevealIt() {

        const url = this.router.url;
        const primaryTab = this.primarySelectedTab === "" ? this.variablesTabs.find((tab) => url.includes(tab.link)) : this.variablesTabs.find((tab) => tab.name === this.primarySelectedTab);
        if (primaryTab) {
            primaryTab.isActive = true;
        }
    }
}
